// React for Website

import React, { useState } from "react";
//outsource
import { Form, Input } from "antd";

//components

const VoucherLastName = () => {
  // -------------------------- VAR --------------------------

  // -------------------------- STATE --------------------------

  // -------------------------- REDUX --------------------------
  // -------------------------- FUNCTION ------------------------

  // -------------------------- EFFECT --------------------------

  // -------------------------- RENDER --------------------------

  // -------------------------- MAIN --------------------------
  return (
    <Form.Item
      name="lastName"
      label="Receiver Last Name"
      rules={[
        {
          required: true,
          message: "Please input Last name",
        },
        {
          max: 32,
          message: "Max length is 32 character",
        },
        {
          pattern: /^[A-Za-z ]+$/,
          message: "Alphabets only",
        },
      ]}
    >
      <Input maxLength={32} showCount placeholder="Please input Last name" />
    </Form.Item>
  );
};

export default VoucherLastName;
